import { defaultBranding, SET_BRANDING_CONFIG } from "actions/branding"

export default (state = defaultBranding, action) => {
	if (action.type === SET_BRANDING_CONFIG) {
		return action.payload
	}
	return state
}
